/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../quiz-api";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getQuiz = /* GraphQL */ `query GetQuiz($id: ID!) {
  getQuiz(id: $id) {
    id
    ownerIdAndWsId
    creator
    name
    requiredPassPercentage
    version
    description
    createdAt
    latestEditor
    updatedAt
    publication_state
    relatedPages
    questionsCount
    questionsOrder
    stats
    meta
    __typename
  }
}
` as GeneratedQuery<APITypes.GetQuizQueryVariables, APITypes.GetQuizQuery>;

export const listQuizzes = /* GraphQL */ `query ListQuizzes(
  $wsId: String!,
  $filter: ModelQuizFilterInput
  $limit: Int
  $nextToken: String
) {
  listQuizzes(wsId: $wsId, filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      ownerIdAndWsId
      creator
      name
      requiredPassPercentage
      version
      description
      createdAt
      latestEditor
      updatedAt
      publication_state
      relatedPages
      questionsCount
      questionsOrder
      stats
      meta
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListQuizzesQueryVariables,
    APITypes.ListQuizzesQuery
>;
export const listQuizByState = /* GraphQL */ `query ListQuizByState(
  $wsId: String!,
  $publication_state: String!
  $filter: ModelQuizFilterInput
  $limit: Int
  $nextToken: String
) {
  listQuizByState(
    wsId: $wsId 
    publication_state: $publication_state
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      ownerIdAndWsId
      creator
      name
      requiredPassPercentage
      version
      description
      createdAt
      latestEditor
      updatedAt
      publication_state
      relatedPages
      questionsCount
      questionsOrder
      stats
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListQuizByStateQueryVariables,
    APITypes.ListQuizByStateQuery
>;
export const getQuizQuestion = /* GraphQL */ `query GetQuizQuestion($id: ID!) {
  getQuizQuestion(id: $id) {
    id
    ownerIdAndWsId
    quizId
    text
    options
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetQuizQuestionQueryVariables,
    APITypes.GetQuizQuestionQuery
>;
export const listQuizQuestions = /* GraphQL */ `query ListQuizQuestions(
  $wsId: String!,
  $quizId: ModelStringInput!
  $sortDirection: ModelSortDirection
  $filter: ModelQuizQuestionFilterInput
  $limit: Int
  $nextToken: String
) {
  listQuizQuestions(
    wsId: $wsId
    quizId: $quizId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      ownerIdAndWsId
      quizId
      text
      options
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListQuizQuestionsQueryVariables,
    APITypes.ListQuizQuestionsQuery
>;
export const getQuizAnswer = /* GraphQL */ `query GetQuizAnswer($id: ID!) {
  getQuizAnswer(id: $id) {
    id
    ownerIdAndWsId
    quizAndUserId
    quizId
    userId
    attempt
    completedAt
    duration
    answers
    score
    status
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetQuizAnswerQueryVariables,
    APITypes.GetQuizAnswerQuery
>;
export const listQuizAnswers = /* GraphQL */ `query ListQuizAnswers(
  $wsId: String!,
  $quizAndUserId: ModelStringInput!
  $sortDirection: ModelSortDirection
  $filter: ModelQuizAnswerFilterInput
  $limit: Int
  $nextToken: String
) {
  listQuizAnswers(
    wsId: $wsId 
    quizAndUserId: $quizAndUserId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      ownerIdAndWsId
      quizAndUserId
      quizId
      userId
      attempt
      completedAt
      duration
      answers
      score
      status
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListQuizAnswersQueryVariables,
    APITypes.ListQuizAnswersQuery
>;
export const getQuizStats = /* GraphQL */ `query GetQuizStats($id: ID!) {
  getQuizStats(id: $id) {
    id
    ownerIdAndWsId
    quizAndUserId
    quizId
    userId
    answerId
    completedAt
    attempt
    score
    status
    userIdAndStatus
    completePercentage
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetQuizStatsQueryVariables,
    APITypes.GetQuizStatsQuery
>;
export const listQuizStats = /* GraphQL */ `query ListQuizStats(
  $wsId: String!,
  $quizAndUserId: ModelStringInput!
  $sortDirection: ModelSortDirection
  $filter: ModelQuizStatsFilterInput
  $limit: Int
  $nextToken: String
) {
  listQuizStats(
    wsId: $wsId
    quizAndUserId: $quizAndUserId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      ownerIdAndWsId
      quizAndUserId
      quizId
      userId
      answerId
      completedAt
      attempt
      score
      status
      userIdAndStatus
      completePercentage
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListQuizStatsQueryVariables,
    APITypes.ListQuizStatsQuery
>;
export const listQuizStatsByUser = /* GraphQL */ `query ListQuizStatsByUser(
  $wsId: String!,
  $userIdAndStatus: ModelStringInput!
  $sortDirection: ModelSortDirection
  $filter: ModelQuizStatsFilterInput
  $limit: Int
  $nextToken: String
) {
  listQuizStatsByUser(
    wsId: $wsId
    userIdAndStatus: $userIdAndStatus
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      ownerIdAndWsId
      quizAndUserId
      quizId
      userId
      answerId
      completedAt
      attempt
      score
      status
      userIdAndStatus
      completePercentage
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListQuizStatsByUserQueryVariables,
    APITypes.ListQuizStatsByUserQuery
>;
